import React, { useState } from "react";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./components/Context/AuthContext";
import Nav from "./components/layout/Nav";
import Celeste from "./components/layout/Celeste";
import Presentation from "./components/layout/Presentation";
import ShopCarousel from "./components/shop/ShopCarousel";
import CartSidebar from "./components/shop/CartSidebar";
import CheckoutModal from "./components/checkout/CheckoutModal";
import AccountModal from "./components/account/AccountModal";
import Contact from "./components/layout/Contact";
import YouTubeGallery from "./components/layout/YouTubeGallery";
import Footer from "./components/layout/Footer";

const App: React.FC = () => {
  const [cartOpen,     setCartOpen]     = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [accountOpen,  setAccountOpen]  = useState(false);

  return (
    <AuthProvider>
      <Nav
        onOpenCart={() => setCartOpen(true)}
        onOpenAccount={() => setAccountOpen(true)}
      />

      <div style={{ height: "var(--nav-height)" }} />

      <Celeste />

      <ShopCarousel />

      <Presentation />
      
      <Contact />

      <YouTubeGallery />

      <Footer />

      <CartSidebar
        isOpen={cartOpen}
        onClose={() => setCartOpen(false)}
        onCheckout={() => setCheckoutOpen(true)}
      />

      <CheckoutModal
        isOpen={checkoutOpen}
        onClose={() => setCheckoutOpen(false)}
      />

      <AccountModal
        isOpen={accountOpen}
        onClose={() => setAccountOpen(false)}
      />

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </AuthProvider>
  );
};

export default App;
